import React from "react";
import { HeadingType } from "../../enums/componentEnums";

const AppHeading = ({
  text,
  type = HeadingType.MAIN,
  className = null,
}: {
  text: string;
  type: HeadingType;
  className?: string | null;
}) => {
  return <h1 className={`${type} ${className}`}>{text}</h1>;
};

export default AppHeading;
